import Loader from "components/general/Loader";
import useDocumentTypesBrief from "hooks/DocumentType/useDocumentTypesBrief";
import { PropsWithChildren, createContext, useContext, useMemo } from "react";

type DocTypeContextValue = {
   doc_types: DocTypeItem[];
   doc_type_options: Options;
   update: () => Promise<void>;
};

const DocTypeContext = createContext({} as DocTypeContextValue );

export default function DocTypeContextProvider({ children }: PropsWithChildren ) {

   const { d: doc_types, update } = useDocumentTypesBrief();
   
   const doc_type_options = useMemo(() => {
      return doc_types?.map( item => ({
         value: item.id,
         label: item.name
      }))
   }, [ doc_types ]);

   return !doc_types || !doc_type_options 
      ? <Loader style={{ height: "100vh" }}/> 
      : (
         <DocTypeContext.Provider value={{
            doc_types,
            doc_type_options,
            update
         }}>
            { children }
         </DocTypeContext.Provider>
      );
}

export const useDocTypeContext = () => useContext( DocTypeContext );
